module.exports = __webpack_public_path__ + "img/jhakaasbg.985d0681.png";